import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import { Provider } from "react-redux";
import "material-icons/iconfont/material-icons.css";
import store from "./store/store";
import { ThemeProvider } from "@material-tailwind/react";
import theme from "./theme";
import ErrorBoundary from "./components/ui/error-boundary";

const root = createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider value={theme}>
        <Provider store={store}>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </Provider>
    </ThemeProvider>
);
